/**
 * Session History API Service
 * Handles all HTTP requests related to session history
 */

import {
  ISessionHistoryFilters,
  ISessionHistoryResponse,
} from '../../interface/sessionHistoryModel';
import api from '../api';

/**
 * Fetch session history with filters and pagination
 * @param filters - Filtering and pagination parameters
 * @returns Promise with session history data including organization-wide summary
 */
const getSessionHistory = async (
  filters: ISessionHistoryFilters,
): Promise<ISessionHistoryResponse> => {
  const response = await api.get('/payment/session/history', {
    params: {
      status: filters.status || undefined,
      startDate: filters.startDate || undefined,
      endDate: filters.endDate || undefined,
      cashierName: filters.cashierName || undefined,
      page: filters.page || 1,
      pageSize: filters.pageSize || 5,
    },
  });
  return response.data;
};

export const sessionHistoryService = {
  getSessionHistory,
};
